<template lang="pug">
v-list(class="print-bg")
    div(:id="ip._id")
        .page(size="Auto")
            div(class="view-width" style="font-size:11px;")
                
                table( class="view-width tableInput" style="margin-top:10px;")
                    thead
                        tr
                            td(class="headerTable" width="150" colspan="7") D. Penilaian Risiko
                        div(style="padding:10px;margin-bottom:1px;font-style: italic")
                            label Gunakan matriks risiko untuk menilai risiko sebelum perubahan & jika perubahan dilakukan
                        img(class="verMiddle" src="../assets/table_matriks.png" width="85%") 

                table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                    tbody
                        tr
                            td(class=" headerTable" width="150" colspan="8") Hasil Tingkat Risiko
                        tr
                            td(class=" headerTable" width="280")
                            td(class=" headerTable" width="180" style="text-align:center") Konsekuensi
                            td(class=" headerTable" width="180" style="text-align:center") Kekerapan / Kemungkinan
                            td(class=" headerTable" width="180" style="text-align:center") Tingkat Risiko
                        tr
                            td(class=" headerTable" width="280") Tingkat Risiko Awal
                            td(width="180" style="text-align:center") {{ip.ipTingkatRisikoAwal.nilaiKonsekuensi}}
                            td(width="180" style="text-align:center") {{ip.ipTingkatRisikoAwal.kekerapan}}
                            td(width="180" style="text-align:center") {{ip.ipTingkatRisikoAwal.tingkatRisiko}}
                        tr
                            td(class=" headerTable" width="280") Tingkat Risiko Setelah Perubahan 
                            td(width="180" style="text-align:center") {{ip.ipTingkatRisikoSetelahPerubahan.nilaiKonsekuensi}}
                            td(width="180" style="text-align:center") {{ip.ipTingkatRisikoSetelahPerubahan.kekerapan}}
                            td(width="180" style="text-align:center") {{ip.ipTingkatRisikoSetelahPerubahan.tingkatRisiko}}
                        
                div(style="padding:10px;margin-bottom:1px;font-style: italic")
                    label Catatan :
                    div 1. Jika nilai risiko Kritis, Tinggi atau Sedang, maka formulir ini harus dilengkapi.
                    div(style="margin-bottom:-5px") 2. Jika Rendah, pengendalian tidak diperlukan, Mintakan persetujuan dari Supervisor atau Team Leader.
                hr
                table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                    tbody
                        tr
                            td(class=" headerTable" width="150" colspan="8") E. Daftar Periksa Dampak dari Perubahan 
                        tr
                            td(width="300" class=" headerTable") 
                                span(style="font-weight:bold") Daftar Periksa 
                                span(style="font-style: italic") (Berikut tanda ✔ pada kolom yang sesuai)
                            td(width="35" class="align-center" class=" headerTable") Ya
                            td(width="35" class=" headerTable") Tidak
                            td(width="250" class=" headerTable") Catatan
                        tr
                            td(width="380") Apakah perubahan perlu perubahan terhadap standar atau prosedur K3L?
                            td(width="35" class="align-center" style="padding:5px") 
                                img(v-if="ip.ipPerluPerubahan.selected == 'YA'" class="verMiddle" src="../assets/check-blue.png" width="13")
                                img(v-else class="verMiddle" src="../assets/uncheck.png" width="13")
                            td(width="5" class="align-center" style="padding:5px") 
                                img(v-if="ip.ipPerluPerubahan.selected == 'TIDAK'" class="verMiddle" src="../assets/check-blue.png" width="13")
                                img(v-else class="verMiddle" src="../assets/uncheck.png" width="13")
                            td(width="200") {{ip.ipPerluPerubahan.description}}
                        tr
                            td(width="380") Apakah perubahan mempengaruhi garansi atau perjanjian pemeliharaan?
                            td(width="35" class="align-center" style="padding:5px") 
                                img(v-if="ip.ipMempengaruhiGaransi.selected == 'YA'" class="verMiddle" src="../assets/check-blue.png" width="13")
                                img(v-else class="verMiddle" src="../assets/uncheck.png" width="13")
                            td(width="5" class="align-center" style="padding:5px") 
                                img(v-if="ip.ipMempengaruhiGaransi.selected == 'TIDAK'" class="verMiddle" src="../assets/check-blue.png" width="13")
                                img(v-else class="verMiddle" src="../assets/uncheck.png" width="13")
                            td(width="200") {{ip.ipMempengaruhiGaransi.description}}
                        tr
                            td(width="380") Apakah perubahan mempengaruhi spesifikasi pekerjaan pemeliharaan?
                            td(width="35" class="align-center" style="padding:5px") 
                                img(v-if="ip.ipMempengaruhiSpek.selected == 'YA'" class="verMiddle" src="../assets/check-blue.png" width="13")
                                img(v-else class="verMiddle" src="../assets/uncheck.png" width="13")
                            td(width="5" class="align-center" style="padding:5px") 
                                img(v-if="ip.ipMempengaruhiSpek.selected == 'TIDAK'" class="verMiddle" src="../assets/check-blue.png" width="13")
                                img(v-else class="verMiddle" src="../assets/uncheck.png" width="13")
                            td(width="200") {{ip.ipMempengaruhiSpek.description}}
                        tr
                            td(width="380") Apakah perubahan memerlukan pemutakhiran gambar?
                            td(width="35" class="align-center" style="padding:5px") 
                                img(v-if="ip.ipPerluUpdate.selected == 'YA'" class="verMiddle" src="../assets/check-blue.png" width="13")
                                img(v-else class="verMiddle" src="../assets/uncheck.png" width="13")
                            td(width="5" class="align-center" style="padding:5px") 
                                img(v-if="ip.ipPerluUpdate.selected == 'TIDAK'" class="verMiddle" src="../assets/check-blue.png" width="13")
                                img(v-else class="verMiddle" src="../assets/uncheck.png" width="13")
                            td(width="200") {{ip.ipPerluUpdate.description}}
                        tr
                            td(width="380") Apakah perubahan mengurangi barang stok?
                            td(width="35" class="align-center" style="padding:5px") 
                                img(v-if="ip.ipMengurangiStok.selected == 'YA'" class="verMiddle" src="../assets/check-blue.png" width="13")
                                img(v-else class="verMiddle" src="../assets/uncheck.png" width="13")
                            td(width="5" class="align-center" style="padding:5px") 
                                img(v-if="ip.ipMengurangiStok.selected == 'TIDAK'" class="verMiddle" src="../assets/check-blue.png" width="13")
                                img(v-else class="verMiddle" src="../assets/uncheck.png" width="13")
                            td(width="200") {{ip.ipMengurangiStok.description}}
                        tr
                            td(width="380") Apakah perubahan memerlukan stok barang atau suku cadang baru?
                            td(width="35" class="align-center" style="padding:5px") 
                                img(v-if="ip.ipStokBaru.selected == 'YA'" class="verMiddle" src="../assets/check-blue.png" width="13")
                                img(v-else class="verMiddle" src="../assets/uncheck.png" width="13")
                            td(width="5" class="align-center" style="padding:5px") 
                                img(v-if="ip.ipStokBaru.selected == 'TIDAK'" class="verMiddle" src="../assets/check-blue.png" width="13")
                                img(v-else class="verMiddle" src="../assets/uncheck.png" width="13")
                            td(width="200") {{ip.ipStokBaru.description}}
                        tr
                            td(width="380") Apakah perubahan menggunakan bahan kimia baru?
                            td(width="35" class="align-center" style="padding:5px") 
                                img(v-if="ip.ipBahanKimia.selected == 'YA'" class="verMiddle" src="../assets/check-blue.png" width="13")
                                img(v-else class="verMiddle" src="../assets/uncheck.png" width="13")
                            td(width="5" class="align-center" style="padding:5px") 
                                img(v-if="ip.ipBahanKimia.selected == 'TIDAK'" class="verMiddle" src="../assets/check-blue.png" width="13")
                                img(v-else class="verMiddle" src="../assets/uncheck.png" width="13")
                            td(width="200") {{ip.ipBahanKimia.description}}
                        tr
                            td(width="380") Apakah perubahan memerlukan persetujuan dari pabrikan?
                            td(width="35" class="align-center" style="padding:5px") 
                                img(v-if="ip.ipPersetujuanPabrik.selected == 'YA'" class="verMiddle" src="../assets/check-blue.png" width="13")
                                img(v-else class="verMiddle" src="../assets/uncheck.png" width="13")
                            td(width="5" class="align-center" style="padding:5px") 
                                img(v-if="ip.ipPersetujuanPabrik.selected == 'TIDAK'" class="verMiddle" src="../assets/check-blue.png" width="13")
                                img(v-else class="verMiddle" src="../assets/uncheck.png" width="13")
                            td(width="200") {{ip.ipPersetujuanPabrik.description}}
                        tr
                            td(width="380") Apakah perubahan berdampak pada pihak lain atau dokumen pendukung?
                            td(width="35" class="align-center" style="padding:5px") 
                                img(v-if="ip.ipBerdampakLain.selected == 'YA'" class="verMiddle" src="../assets/check-blue.png" width="13")
                                img(v-else class="verMiddle" src="../assets/uncheck.png" width="13")
                            td(width="5" class="align-center" style="padding:5px") 
                                img(v-if="ip.ipBerdampakLain.selected == 'TIDAK'" class="verMiddle" src="../assets/check-blue.png" width="13")
                                img(v-else class="verMiddle" src="../assets/uncheck.png" width="13")
                            td(width="200") {{ip.ipBerdampakLain.description}}         

                table(
                  v-if="ip.ipTindakanPengendalian && ip.ipTingkatRisikoSetelahPerubahan.tingkatRisiko > 4" 
                  class="view-width tableInput autoPageBreak" 
                  style="margin-top:10px;"
                )
                    tbody
                        tr
                            td(class=" headerTable" width="150" colspan="8") F. Pengendalian Risiko
                        tr
                            td(class=" headerTable") Tindakan yang diperlukan untuk pengendalian 
                            td(class=" headerTable" width="100") Oleh
                            td(class=" headerTable") Status
                            td(class=" headerTable align-center" width="70") Lampiran 
                            td(class=" headerTable" width="210") Catatan
                        tr( v-for="(item, index) in ip.ipTindakanPengendalian" :key="index")
                            td {{item.titleTindakan}}
                            td {{item.penanggungJawab.name}}
                            td {{item.statusTindakan}}
                            td(class="align-center" style="padding:4px")
                              img(v-if="item.lampiran.docPendukung" class="verMiddle" src="../assets/file-import.png" width="12" style="cursor: pointer" @click="download(item.lampiran.docPendukung)")
                              v-flex(v-else)
                            td {{ item.description }}

                table( 
                  v-if="ip.ipTingkatRisikoSetelahPerubahan.tingkatRisiko > 4"
                  class="view-width tableInput autoPageBreak" 
                  style="margin-top:10px;"
                )
                    tbody
                        tr
                            td(class=" headerTable" width="150" colspan="8") Tingkat Risiko Setelah Dikendalikan
                        tr
                            td(class=" headerTable" width="280")
                            td(class=" headerTable" width="180" style="text-align:center") Konsekuensi
                            td(class=" headerTable" width="180" style="text-align:center") Kekerapan / Kemungkinan
                            td(class=" headerTable" width="180" style="text-align:center") Tingkat Risiko
                        tr
                            td(class=" headerTable" width="280") Tingkat Risiko Akhir
                            td(width="180" style="text-align:center") {{ ip.ipTingkatSetelahDikendalikan ? ip.ipTingkatSetelahDikendalikan.nilaiKonsekuensi : '' }}
                            td(width="180" style="text-align:center") {{ ip.ipTingkatSetelahDikendalikan ? ip.ipTingkatSetelahDikendalikan.kekerapan : '' }} 
                            td(width="180" style="text-align:center") {{ ip.ipTingkatSetelahDikendalikan ? ip.ipTingkatSetelahDikendalikan.tingkatRisiko : '' }} 
</template>

<script>

import * as config from "../config/index.json";
import helper from "../helper/index.js";
import { mapState } from 'vuex';
import printJS from 'print-js';
export default {
  name: 'UsulanSecondView',
  components: {
  },
  props: {
    dialogType: String,
    ip: Object,
    approvalUser: Object
  },
  mounted() {
  },
  data: () => ({
    formName: config.FormName,
    dialog: false,
    regex: /\//gi,
    approvalDialog: false,
    approvalDialog2: false,
    comment: '',
    approval: null,
    share: false,
    print: false,
  }),
  computed: {
    ...mapState(['API_URL', "networks", "sharing", "shortenUrl", "dataUsers"]),
    locations(){
        let temp = []
        for (const index in this.ip.ipLocation) {
            temp.push(this.ip.ipLocation[index].name)
        }
        return temp
    },
  },
  methods: {
    download(file) {
        this.$downloadFile(file);
    },
    shareIP() {
        this.$store.dispatch("getShortenUrl", {ip: this.ip, 
        approvalUser: this.approvalUser, context: this.share}).then(() => {
            this.share = true;
        });
    },
    printIP(id){
        printJS({
            printable: id, 
            type: 'html',
            scanStyles: false,
            css: ["/stylesheets/main.css" ,"/stylesheets/approval.css", "/stylesheets/vuetify.min.css", '/stylesheets/view.css', "/stylesheets/ck-content.css"]
        });
    },
    formatDate: helper.formatDateOnly,
    getApproveStatus(wf){
        let status = 0;
        for(let i=0;i<wf.length;i++){
            if(wf[i].nik == this.approvalUser.nik && !this.isCurrentApprover()){
                status=wf[i].status;
                break;
            }
        }
        return status;
    },
    getApproveDate(wf){
        let approvedWf = null;
        for(let i=0;i<wf.length;i++){
            if(wf[i].nik == this.approvalUser.nik){
                approvedWf=wf[i];
                break;
            }
        }
        return approvedWf.date;
    },
    isCurrentApprover(){
        if (this.ip.ipStatus == 2) {
            for (const wf of this.ip.ipWorkflow) {
                if (this.$store.getters.isAuthenticated) {
                    if ((wf.status == 9) && (wf.approverId == this.dataUsers.nik)) {
                        return true;
                    }
                }
            }
        }
        return false
    },
    approvalTime(date){
        return new Date(date).toLocaleString('en-GB');
    }
  },
  watch: {
    // approvalDialog2 (val) {
    //     if (!val) return
    //     let formData = new FormData();
    //     formData.append('_id', this.ip._id);
    //     formData.append('status', parseInt(this.approval));
    //     formData.append('comment', this.comment);
    //     formData.append('approvalUser', JSON.stringify(this.approvalUser));
        
    //     formData.append('formCode', this.ip.ipForm);
    //     const config = {
    //         method: "put",
    //         url: `${this.API_URL}/v1/requests/approvalAttachment`,
    //         headers: {"Authorization": `Bearer ${this.$store.state.token}`},
    //         data: formData
    //     };
    //     axios(config).then(res => {
    //         if (res.status == 200) {
    //             setTimeout(() => {
    //                 this.dialog2 = false;
    //                 this.dialog = false;
    //                 location.reload();
    //             },
    //             1000);
    //         }
    //     });
     
    // }
    
  }
};
</script>
<style scoped>
.ck-editor__editable {
    min-height: 200px !important;
    max-height: 600px !important;
}
.print-bg {
  background: rgb(204,204,204);
  padding-top: 10px;
}
.print-bg > div{
  text-align:center;
}
.page {
  background: white;
  display: block;
  margin: 5px auto;
  padding: 0.7cm 1cm 0.8cm;
  position: relative;
}
.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}
.page[size="Auto"] {
  width: auto;
  margin:0 auto;
  display:inline-block;
  text-align:initial;
}
.view-width {
  width: 19cm;
}
.print-header {
  border-collapse: collapse;
  text-align: right;
}
.padding-x-3 {
  padding:0 3px;
}
.padding-xy-5 {
  padding:2px;
}
.padding-xy-1 {
  padding:1px;
}
.margin-tl-5 {
  margin: 3px 5px 0 5px;
}
.margin-tl-10 {
  margin: 3px 10px 0 10px;
}
.margin-tl-25 {
  margin: 3px 15px 0 25px;
}
.logo-cell {
  padding:8px 5px 0px;
  width:35%;
}
.detail-wrap {
  margin-top: 5px;
}
.border-left-0 {
  border-left: 0;
}
.border-right-0 {
  border-right: 0;
}
.approved {
  text-align: center;
  padding:5px;
}
.ff0000 {
  color: #ff0000;
}
.align-center {
  text-align: center;
}
.align-left {
 align-items: left;
}
.width-20p {
  width:20%;
}
.width-25p {
  width:25%;
}
.height-40px {
  height: 40px;
}
.width-300px {
  width: 250px;
}
.top-align {
  vertical-align:top;
}
.navFixed {
  position: fixed;
  z-index: 9;
}
.padTop60 {
  padding-top:60px;
}
.blink {
	-webkit-animation: blink 2s steps(5, start) infinite;
  animation: blink 2s steps(5, start) infinite;
  color: #dddddd;
}
@-webkit-keyframes blink { to { color: #ffffff; }}
@keyframes blink { to { color: #ffffff; }}
@media print {
    
}
table {
  border-collapse: collapse;
}
.headerTable{
    border: 1px solid black; 
    background-color: #cccccc;
    font-weight: 600;
}
.tableInput td{
    border: 1px solid black;
    padding-left: 5px;
}
.verMiddle{
    vertical-align:middle;
}
.comment{
    word-break: break-all;
}
.tableCollapse td{
    border: 1px solid black;
    border-top: 0;
    padding-left: 5px;
}
.emptySign {
    width:25px;
}
#background {
  position:absolute;
  z-index:0;
  /* display:block; */
  top:150px;
  left:0px;
  text-align: center;
  width: 100%;
}
.imgWatermark {
  width: 650px;
  position:absolute;
  top:0px;
  right:50px;
  opacity: 0.65;
}
.fontWatermarkUp {
  font-size:450%; 
  position:absolute;
  transform: rotate(-30deg);
  opacity: 0.65;  
  right: 200px;
  color: rgb(224,224,224);
}
.fontWatermarkDown {
  font-size:450%; 
  position:absolute;
  transform: rotate(-30deg);
  opacity: 0.65;  
  top: 450px;
  right: 100px;
  color: rgb(224,224,224);
}
</style>